import { BDMatrixFilter } from '@models/bdMatrixFilter.model';

export class FinancialReviewFilter extends BDMatrixFilter {
  studyId: number;
  isConsolidated?: boolean;
  isFunctionalCurrency?: boolean;
  filingTypeId?: number;
}
